export default "__VITE_ASSET__rdelJlM5__"